import { Box } from '@mui/material';
import { ATSConnectImportCandidateFormTestIds } from 'data-testids/ATS';
import { useWatch } from 'react-hook-form';

import {
  BoldTitle,
  Form,
  Key,
  ModalContainer,
  Row,
  SubContainer,
} from '../../../styles/hiringRequestStyles';
import { LandingFormProps } from '../../../types/hiringRequestTypes';
import { HiringRequestFormContainer } from './HiringRequestFormContainer';
import { SchoolSelectorSubcontainer } from './SchoolSelectorSubcontainer';
import { SelectRoleSubContainer } from './SelectRoleSubcontainer';
import auth from 'utils/auth';

export const LandingForm: React.FC<LandingFormProps> = ({
  candidateEmail,
  candidateId,
  candidateName,
  onClose,
  onSubmit,
}) => {
  const selectedRole = useWatch({ name: 'role' });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <ModalContainer sx={{ width: 'inherit' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <BoldTitle variant="h1" data-testid={ATSConnectImportCandidateFormTestIds.TITLE}>
            Request to Hire {candidateName}
          </BoldTitle>
        </Box>
        <SubContainer>
          <Row data-testid={ATSConnectImportCandidateFormTestIds.CANDIDATE_NAME}>
            <Key>Candidate:</Key> &nbsp;{candidateName}
          </Row>
          <Row data-testid={ATSConnectImportCandidateFormTestIds.CANDIDATE_EMAIL}>
            <Key>Candidate email:</Key> &nbsp; {candidateEmail}
          </Row>
        </SubContainer>
        <SelectRoleSubContainer />
        {auth.isSuperAdminUser() && selectedRole && <SchoolSelectorSubcontainer />}
        <HiringRequestFormContainer
          candidateId={candidateId}
          candidateName={candidateName}
          candidateEmail={candidateEmail}
          onClose={onClose}
        />
      </ModalContainer>
    </Form>
  );
};
